import React, { Component } from 'react';
import {Card, CardBody, Col, Button, ButtonToolbar} from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import DomainOffer from './DomainOffer';
import { Domains } from '../../../services/Domains';
import { reserveDomain } from '../../../redux/actions/domainsActions';
import { connect } from 'react-redux';
import withErrorNotification from '../../../hof/withErrorNotification';
import Notifications from '../../../hof/notifications';

class SearchForDomains extends Component {
    constructor() {
        super();
        this.state = {
            phrase: '',
            offers: [],
            loading: false
        }
    }

    handleChange(event) {
        this.setState({
            phrase: event.target.value
        });
    }

     handleSearch = async (e) => {
        await withErrorNotification(async () => {
            e.preventDefault();
            this.setState({ loading: true, offers: [] })
            const offers = await Domains.search(this.state.phrase);
            console.log(offers);
            this.setState({
                offers: offers,
                loading: false
            })
        })
    }

    render() {
        const {t} = this.props;
        return (
            <Col md={12} lg={12}>
                <Card>
                    <CardBody>
                        <div className="wizard card-body">
                            <div className="wizard__form-wrapper">
                                <form className="form form--horizontal wizard__form" onSubmit={this.handleSearch}>
                                    <h3 className="wizard__title">{t('domains.find_domains.title')}</h3>
                                    <div className="form__form-group">
                                        <input type='text' placeholder={t('domains.find_domains.placeholder')} value={this.state.phrase} onChange={(e) => this.handleChange(e)}/>
                                        <ButtonToolbar className="form__button-toolbar wizard__toolbar">
                                            <Button color="primary" className="next">{t('domains.find_domains.search')}</Button>
                                        </ButtonToolbar>
                                    </div>
                                    {this.state.loading && <h4 className="wizard__title">{t('domains.find_domains.loading')}</h4>}
                                </form>
                            </div>
                            {this.state.offers && this.state.offers.map((offer, i) => {
                                return (
                                    <DomainOffer key={i} offer={offer} onReserve={async () => {
                                        await withErrorNotification(async () => {
                                            const reserved = await Domains.reserve(offer.domainName);
                                            console.log(`Reserved: ${offer.domainName}`, reserved);
                                            this.props.onReserveDomain(reserved);
                                            Notifications.showNotification(
                                                t('domains.find_domains.messages.reserved.title'),
                                                t('domains.find_domains.messages.reserved.body'),
                                                Notifications.Colors.SUCCESS);
                                        })
                                    }}/>
                                )
                            })}
                        </div>
                    </CardBody>
                </Card>
            </Col>
        )
    }
}

SearchForDomains.propTypes = {
    t: PropTypes.func.isRequired,
};

const mapsDispatchToProps = (dispatch) => {
    return {
        onReserveDomain: (domain) => dispatch(reserveDomain(domain))
    }
}
export default connect(null, mapsDispatchToProps)(withTranslation('dashboard')(SearchForDomains));
